export const ulybkaTenant = {
  tenant: 'ulybka',
  branding: {
    appName: 'Ulybka PRO',
    shortName: 'UlybkaPRO',
    logoSrc: null,
    primaryColor: '#1B7FE5',
    basePaths: {
      patient: '/',
      staff: '/',
    },
  },
  clinic: {
    legalName: 'ООО «СТОМАТОЛОГИИ МСК»',
    legalDetails: 'УлыбкаPRO · УлыбкаPRO\u2032fi',
    address: 'г. Москва, 3-й Автозаводский проезд, 4 · ул. Автозаводская, 7',
    workHours: 'Ежедневно 09:00 – 21:00',
    phone: '+7 (495) 032-10-17',
    phoneTel: '+74950321017',
    email: 'info@ulybka.pro',
    website: 'https://ulybkamsk.ru',
    websiteLabel: 'ulybkamsk.ru',
    whatsappUrl: 'https://wa.me/79629553535',
    whatsappLabel: '+7 962 955-35-35',
    telegramUrl: 'https://t.me/ulybkaPro1',
    telegramLabel: '@ulybkaPro1',
    telegramNotifyUrl: 'https://t.me/ulybkapro_notify_bot',
    telegramNotifyLabel: '@ulybkapro_notify_bot',
    maxBotUrl: 'https://max.ru/id7725316685_bot',
    maxBotLabel: 'id7725316685_bot',
    vkUrl: 'https://vk.com/club219860629',
    youtubeUrl: 'https://www.youtube.com/@ulybkapro',
    publicLogoUrl: 'https://ulybkamsk.ru/uploads/logo_up.png',
    publicAccentColor: 'rgba(198, 172, 74, 1)',
    patientPortalUrl: 'https://lk.ulybkamsk.ru/',
    patientPortalLabel: 'lk.ulybkamsk.ru',
  },
  capabilities: {
    supportsChat: true,
    supportsMessages: false,
    supportsCommunicationPreferences: true,
    supportsGiftCertificates: true,
    supportsCorporatePrograms: true,
    supportsOnlineAppointments: true,
    supportsVerificationWorker: true,
    supportsPlansMis: true,
    supportsDmsGuide: true,
    supportsYandexSplit: true,
    supportsInstallments: true,
    supportsQuestionnaires: true,
    supportsGuestCatalog: true,
    supportsPromotions: true,
    supportsContentLibrary: true,
    supportsReviews: true,
    supportsActivityFeed: false,
    supportsBusinessLeads: false,
    supportsStaffPayments: true,
    supportsDiagnocat: true,
    supportsStaffPromotions: true,
    supportsStaffContent: true,
    supportsStaffAnalytics: true,
    supportsPatientDrilldown: true,
    supportsStaffReports: true,
  },
} as const
